import { Field } from '@availity/form';
import React, { useEffect, useState } from 'react';

export interface CustomNumberFieldProps {
    formKey: string;
    value: string;
    updateValue: (value: string) => void;
    suffix: string;
    includeDecimals?: boolean;
    decimalPoints?: number;
    disabled: boolean;
}
export const CustomNumberField = (props: CustomNumberFieldProps) => {
    const [suffix, setSuffix] = useState<string>();
    const [value, setValue] = useState<string>();

    useEffect(() => {
        setSuffix(' ' + props.suffix);
        setValue(props.value ?? '0');
    }, [props]);

    const validate = (event: any, keyprop: string) => {
        if (props.includeDecimals)
            return validateWithDecimals(event, keyprop, props.decimalPoints);
        else return validateInts(event);
    };

    const validateInts = (event: any) => {
        if (
            !/[0-9]/.test(event.key) &&
            event.key != 'Backspace' &&
            event.key != 'ArrowRight' &&
            event.key != 'ArrowLeft' &&
            event.key != 'Tab'
        ) {
            return true;
        }
        return false;
    };

    const validateWithDecimals = (
        event: any,
        keyprop: string,
        maxDecimals: number
    ) => {
        const countDecimals = (x: string) => {
            const match = x.match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
            if (!match) return 0;
            return Math.max(
                0,
                (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0)
            );
        };

        const decimalCount = countDecimals(
            keyprop.toString().replace(suffix, '')
        );
        const isChangeAfterDot =
            (event.target as HTMLTextAreaElement).selectionStart >
            keyprop.toString().replace(suffix, '').length - 2;
        const isWithinDecimalLimit = decimalCount < maxDecimals;

        if (
            !/[0-9]/.test(event.key) &&
            event.key !== 'Backspace' &&
            event.key !== 'ArrowRight' &&
            event.key !== 'ArrowLeft' &&
            event.key !== 'Tab' &&
            (event.key !== '.' || keyprop.toString().includes('.'))
        ) {
            return true;
        }

        if (event.key === '.' && isWithinDecimalLimit && !isChangeAfterDot) {
            return true;
        }

        if (
            /[0-9]/.test(event.key) &&
            isChangeAfterDot &&
            !isWithinDecimalLimit
        ) {
            return true;
        }

        return false;
    };

    return suffix ? (
        <Field
            disabled={props.disabled}
            type="text"
            name={props.formKey}
            value={value.toString().includes(suffix) ? value : value + suffix}
            min={1}
            onKeyDown={(event) => {
                if (validate(event, value)) {
                    event.preventDefault();
                }
            }}
            onChange={(event) => {
                let tvalue = event.target.value;
                for (let i = 0; i < suffix.length; i++) {
                    tvalue = tvalue.replace(suffix[i], '');
                }
                if (
                    !event.target.value.includes(suffix) &&
                    value.toString().includes(suffix)
                        ? value.toString().slice(0, -suffix.length)
                        : value == tvalue
                ) {
                    tvalue = event.target.value.slice(0, -suffix.length);
                }

                const newValue = tvalue.replace(' ', '') + suffix;
                props.updateValue(newValue);
            }}></Field>
    ) : (
        <></>
    );
};
